var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuts1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 200,
    cy: 200,
    r: 200
  }), /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 200,
    cy: 200,
    r: 200
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e",
    cx: 200,
    cy: 200,
    r: 200
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M0 0c106.591 0 193 86.409 193 193S106.591 386 0 386z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    fill: "#F7CC7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6AE",
    fillRule: "nonzero",
    d: "M310 311c6.627 0 12 5.373 12 12s-5.373 12-12 12H189l-.001.01c-6.395.263-11.499 5.53-11.499 11.99s5.104 11.727 11.499 11.99l.001.01h3c6.627 0 12 5.373 12 12s-5.373 12-12 12h-76c-6.627 0-12-5.373-12-12s5.373-12 12-12h4c6.627 0 12-5.373 12-12s-5.373-12-12-12H79c-6.627 0-12-5.373-12-12s5.373-12 12-12h231zm-20-144c6.627 0 12 5.373 12 12s-5.373 12-12 12h-19v.01c-6.395.263-11.5 5.53-11.5 11.99s5.105 11.727 11.5 11.99v.01h80c6.627 0 12 5.373 12 12s-5.373 12-12 12h-20l-.001.01c-6.395.263-11.499 5.53-11.499 11.99s5.104 11.727 11.499 11.99l.001.01h1c6.627 0 12 5.373 12 12s-5.373 12-12 12h-76c-6.627 0-12-5.373-12-12s5.373-12 12-12h6c6.627 0 12-5.373 12-12s-5.373-12-12-12H120c-6.627 0-12-5.373-12-12s5.373-12 12-12h9c6.627 0 12-5.373 12-12s-5.373-12-12-12H59c-6.627 0-12-5.373-12-12s5.373-12 12-12h231zm-173 96c6.627 0 12 5.373 12 12s-5.373 12-12 12H41c-6.627 0-12-5.373-12-12s5.373-12 12-12h76zm326-48c6.627 0 12 5.373 12 12s-5.373 12-12 12h-41c-6.627 0-12-5.373-12-12s5.373-12 12-12h41zM-9.5 167c6.627 0 12 5.373 12 12s-5.373 12-12 12h-44c-6.627 0-12-5.373-12-12s5.373-12 12-12h44zM278 119c6.627 0 12 5.373 12 12s-5.373 12-12 12h-62c-6.627 0-12-5.373-12-12s5.373-12 12-12h62zm-139 0c6.627 0 12 5.373 12 12s-5.373 12-12 12h-20c-6.627 0-12-5.373-12-12s5.373-12 12-12h20zm158-96c6.627 0 12 5.373 12 12s-5.373 12-12 12h-68l-.001.01c-6.395.263-11.499 5.53-11.499 11.99S222.604 70.727 229 70.99L229 71h3c6.627 0 12 5.373 12 12s-5.373 12-12 12h-76c-6.627 0-12-5.373-12-12s5.373-12 12-12h4c6.627 0 12-5.373 12-12s-5.373-12-12-12H40c-6.627 0-12-5.373-12-12s5.373-12 12-12h257zm3 48c6.627 0 12 5.373 12 12s-5.373 12-12 12h-20c-6.627 0-12-5.373-12-12s5.373-12 12-12h20zm-192 0c6.627 0 12 5.373 12 12s-5.373 12-12 12H88c-6.627 0-12-5.373-12-12s5.373-12 12-12h20z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E29F58",
    fillRule: "nonzero",
    d: "M205 263c6.627 0 12 5.373 12 12s-5.373 12-12 12h-62c-6.627 0-12-5.373-12-12s5.373-12 12-12h62zM99 203c0-6.627-5.373-12-12-12H2c-6.627 0-12-5.373-12-12s5.373-12 12-12h14c6.627 0 12-5.373 12-12s-5.373-12-12-12h-30c-6.627 0-12-5.373-12-12s5.373-12 12-12h156c6.627 0 12 5.373 12 12s-5.373 12-12 12H64v.01c-6.395.262-11.5 5.53-11.5 11.99s5.105 11.728 11.5 11.99v.01h160c6.627 0 12 5.373 12 12s-5.373 12-12 12h-68l-.001.01c-6.395.263-11.499 5.53-11.499 11.99s5.104 11.727 11.499 11.99l.001.01h3c6.627 0 12 5.373 12 12s-5.373 12-12 12H83c-6.627 0-12-5.373-12-12s5.373-12 12-12h4c6.627 0 12-5.373 12-12zm128 12c6.627 0 12 5.373 12 12s-5.373 12-12 12h-20c-6.627 0-12-5.373-12-12s5.373-12 12-12h20zm176 0c6.627 0 12 5.373 12 12s-5.373 12-12 12H302c-6.627 0-12-5.373-12-12s5.373-12 12-12h101zm-368 0c6.627 0 12 5.373 12 12s-5.373 12-12 12H15c-6.627 0-12-5.373-12-12s5.373-12 12-12h20zm313-48c6.627 0 12 5.373 12 12s-5.373 12-12 12h-20c-6.627 0-12-5.373-12-12s5.373-12 12-12h20z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    mask: "url(#f)",
    opacity: 0.078,
    d: "M201-25h225v450H201z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(201 7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#C08240",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 194,
    r: 185,
    fill: "#A34D28",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 193,
    r: 83,
    fill: "#FAD14C",
    mask: "url(#h)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuts1);
export default __webpack_public_path__ + "static/media/Guts1.1a94aa02c54e1742e5c53e0a2ae9056b.svg";
export { ForwardRef as ReactComponent };